import React from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DatePickerMui from '../../../../common/DatePickerMui';
import DateFnsUtils from '@date-io/date-fns';

const DatePicker = ({ selectedDate, onChange }) => {
  const handleDateChange = (date) => {
    onChange(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <DatePickerMui
        label="Select Date"
        value={selectedDate ? selectedDate.toDate() : null}
        onChange={handleDateChange}
        views={['month', 'year']}
        format="MMMM yyyy"
        openTo="month"
        style={{
          '& .MuiInputBase-root': {
            height: '40px',
            fontSize: '1.2rem',
          },
          '& .MuiInputLabel-root': {
            fontSize: '1.2rem',
          },
          '& .MuiSvgIcon-root': {
            fontSize: '1.5rem',
          },
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;